import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { GetCardsByBoardResponse, GetCardsByPhaseResponse, Kanban, PhaseFormSubmissionResponse } from './kanban.model'
import { environment } from '../../../environments/environment'
import { KanbanFiltersHelper } from './kanban-filters.helper'

@Injectable({
  providedIn: 'root'
})
export class PvtKanbanService {
  private http = inject(HttpClient)

  getBoard(boardId: string): Observable<Kanban.Board.Entity> {
    return this.http.get<Kanban.Board.Entity>(`${environment.apiURL}/kanban-management/v1/boards/${boardId}`)
  }

  getCards(boardId: string, filters: Kanban.Card.Filters.Filter[] = []): Observable<GetCardsByBoardResponse> {
    return this.http.get<GetCardsByBoardResponse>(
      `${environment.apiURL}/kanban-management/v1/cards/board/${boardId}`,
      { params: KanbanFiltersHelper.mapFiltersToQueryParam(filters) }
    )
  }

  getCardsByPhase(
    boardId: string,
    phaseId: string,
    offset: number = 0,
    filters: Kanban.Card.Filters.Filter[] = []
  ): Observable<GetCardsByPhaseResponse> {
    const params = KanbanFiltersHelper.mapFiltersToQueryParam(filters).set('offset', offset.toString())
    return this.http.get<GetCardsByPhaseResponse>(
      `${environment.apiURL}/kanban-management/v1/cards/board/${boardId}/phase/${phaseId}`,
      { params }
    )
  }

  moveCard(boardId: string, cardId: string, phaseId: string) {
    return this.http.patch(
      `${environment.apiURL}/kanban-management/v1/cards/board/${boardId}/${cardId}/move`,
      { phaseId }
    )
  }

  getCardById(boardId: string, cardId: string) {
    return this.http.get<Kanban.Card.Entity>(
      `${environment.apiURL}/kanban-management/v1/cards/board/${boardId}/${cardId}`
    )
  }

  getCardHistory(boardId: string, cardId: string) {
    return this.http.get<Kanban.Card.History.Entry[]>(
      `${environment.apiURL}/kanban-management/v1/cards/board/${boardId}/${cardId}/history`
    )
  }

  getPhaseFormSubmission(
    boardId: string,
    cardId: string,
    phaseId: string
  ): Observable<PhaseFormSubmissionResponse> {
    return this.http.get<PhaseFormSubmissionResponse>(
      `${environment.apiURL}/kanban-management/v1/cards/board/${boardId}/${cardId}/phases/${encodeURIComponent(phaseId)}/form`
    )
  }

  submitPhaseForm(
    boardId: string,
    cardId: string,
    phaseId: string,
    data: Record<string, unknown>
  ): Observable<Kanban.Card.Entity> {
    return this.http.post<Kanban.Card.Entity>(
      `${environment.apiURL}/kanban-management/v1/cards/board/${boardId}/${cardId}/phases/${encodeURIComponent(phaseId)}/form`,
      { data }
    )
  }
}
